import { NgClass, NgFor, NgIf } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { PreventDefaultDirective } from 'src/app/directive/prevent-default.directive';

@Component({
  selector: 'app-relation-picker',
  imports: [NgFor, NgIf, NgClass, PreventDefaultDirective],
  templateUrl: './relation-picker.component.html',
  styleUrl: './relation-picker.component.scss',
})
export class RelationPickerComponent implements OnChanges {
  @Input() relations: any[] = [];
  @Input() lines: any[] = [];
  @Output() selection = new EventEmitter();
  @Input() productTitle: string = '';

  selectOption(relation: any, option: any) {
    if (relation?.value == option?.label) return;
    if (option?.options?.length == 0) return;
    this.selection.emit({ relation, option });
    for (let relation of this.relations) {
      relation._active = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {}

  openRelation(relation: any) {
    for (let relation of this.relations) {
      relation._active = false;
    }
    relation._active = true;
  }

  @HostListener('window:click')
  clickedOutside() {
    for (let relation of this.relations) {
      relation._active = false;
    }
  }
}
